<template>
  <div>
    <!-- 头部 -->
    <header class="common-header">
      <div class="left f fw-w">
        <el-select v-model="parameter.virtualWarehouseIds" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="商品分组" @change="searchGetProductList" style="width:160px;">
          <el-option v-for="item in virtualWarehouses" :key="item.id" :label="item.virtualWarehouseName" :value="item.id" :title="item.virtualWarehouseName"/>
        </el-select>
        <el-select v-model="parameter.spuStatus" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="商品状态" style="width:150px;" @change="searchGetProductList">
          <el-option label="缺货" value="40" />
          <el-option label="在售" value="10" />
          <el-option label="下架(滞销下架)" value="02" />
          <el-option label="下架(缺货下架)" value="01" />
          <el-option label="下架(品控下架)" value="03" />
          <el-option label="下架(侵权下架)" value="04" />
          <el-option label="下架(1688下架)" value="05" />
        </el-select>
        <el-cascader placeholder="请选择品类" size="medium" :options="categoryOptions" :props="{ multiple: true, value: 'categoryId', label: 'name', children: 'childList', emitPath: false }" :show-all-levels="false" filterable collapse-tags clearable v-model="categoryValue" @change="selectCategory" style="width: 260px;">
          <template slot-scope="{ node, data }">
            <span>{{ data.name }}</span>
            <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
          </template>
        </el-cascader>
        <el-select v-model="parameter.supplierNames" size="medium" clearable multiple collapse-tags filterable remote placeholder="供应商" @change="searchGetProductList" style="width:160px;" :remote-method="getSupplierNameList" :loading="getSupplierLoading" @blur="getSupplierNameList" @clear="reloadSupplierNameList" @focus="reloadSupplierNameList">
          <el-option v-for="item in supplierNames" :key="item.id" :label="item.supplier_name" :value="item.supplier_name" :title="item.supplier_name"/>
        </el-select>
        <el-select v-model="parameter.spuCurrentDevelopmentNames" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="买手" @change="searchGetProductList" style="width:160px;">
          <el-option v-for="item in buyerStaffs" :key="item" :label="item" :value="item" :title="item"/>
        </el-select>
        <!-- <el-select v-model="parameter.spuBuyerNames" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="采购员" @change="searchGetProductList" style="width:160px;">
          <el-option v-for="item in buyerStaffs" :key="item" :label="item" :value="item" :title="item"/>
        </el-select> -->
        <el-select v-model="parameter.stockingDays" size="medium" clearable multiple collapse-tags filterable remote reserve-keyword placeholder="备货周期" @change="searchGetProductList" style="width:160px;">
          <el-option v-for="item in stockingDaysSelect" :key="item" :label="item" :value="item" :title="item"/>
        </el-select>
        <div>
          <el-select v-model="parameter.paramType"  size="medium" placeholder="SPU销量" style="width: 100px;">
              <el-option label="SPU销量" :value="1"/>
          </el-select>
          <span class="range-num">
            <el-input style="width:100px" size="medium" v-model="parameter.totalSaleNumStart" clearable @input="handleInput(parameter.totalSaleNumStart,1)"  @change="searchGetProductList"/>
            ~
            <el-input v-model="parameter.totalSaleNumEnd" size="medium" clearable style="width:100px" @input="handleInput(parameter.totalSaleNumEnd,2)" @change="searchGetProductList"/>
          </span>
        </div>
        <div>
          <el-select v-model="parameter.searchType" size="medium" style="width:100px;" class="rightBorderNone">
            <el-option label="SPU" :value="1" />
            <el-option label="商品名称" :value="2" />
            <el-option label="备注" :value="3" />
          </el-select>
          <el-popover placement="bottom"  size="medium" width="400" trigger="click" v-if="parameter.searchType === 1" style="margin-right:10px">
            <el-input v-model="parameter.searchArray" size="medium" placeholder="支持批量搜索" style="width:250px" clearable slot="reference">
              <el-button slot="append" icon="el-icon-search" @click="searchGetProductList"></el-button>
            </el-input>
            <el-input v-model="parameter.searchArray" placeholder="支持批量搜索" size="medium" type="textarea" style="width:100%" clearable @change="searchGetProductList" :rows="6"></el-input>
          </el-popover>
          <el-input v-if="parameter.searchType === 2" v-model="parameter.searchArray" size="medium" placeholder="输入商品名称" style="width:270px;margin-right:10px" clearable>
            <el-button slot="append" icon="el-icon-search" @click="searchGetProductList"></el-button>
          </el-input>
          <el-input v-if="parameter.searchType === 3" v-model="parameter.searchArray" size="medium" placeholder="输入备注" style="width:270px;margin-right:10px" clearable>
            <el-button slot="append" icon="el-icon-search" @click="searchGetProductList"></el-button>
          </el-input>
        </div>
        <el-button size="medium" @click="dataExport">自定义导出</el-button>
        <el-button size="medium" @click="showDialog">列表字段配置</el-button>
        <el-button size="medium" :disabled="!selection.length" @click="batchSpuStatus">批量修改状态</el-button>
      </div>
    </header>

    <!-- 主体 -->
    <section class="common-section">
      <el-table :data="productData" v-loading="loading" height="100%" ref="multiTable" @selection-change="handleSelectionChange" @sort-change="tableSortChange" :row-key="tableRowKey" lazy :load="dataChildrenLoad" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column type="selection" width="50"/>
        <el-table-column v-for="(item,index) in columns" :key="index" :sortable="item.sort" :prop="item.value" :label="item.title" :min-width="item.width" :fixed="item.fixed">
          <template slot-scope="{row}">
            <span v-if="item.title === '商品信息'"> 
              <el-popover placement="right" width="280" trigger="hover">
                <el-image :src="row.productPath" fit="cover" />
                <el-image slot="reference" :src="row.productPath | imgToWebp" fit="cover" class="stock-img"/>
              </el-popover>
              <div style="display: inline-block;margin-left: 10px">
                <el-tooltip v-if="row.productName" class="item" effect="dark" :content="row.productName" placement="top-start">
                  <div class="ellipsis" style="width:250px;">标题: {{ row.productName }}</div>
                </el-tooltip>
                <el-tooltip v-if="row.fullCategoryName" class="item" effect="dark" :content="row.fullCategoryName" placement="top-start">
                  <div class="ellipsis" style="width:250px;">品类: {{ row.fullCategoryName }}</div>
                </el-tooltip>
                <div v-if="row.spuCode">SPU: {{ row.spuCode }}</div>
                <div v-if="row.skuCode">SKU: {{ row.skuCode }}</div>
              </div>
            </span>
            <span v-else-if="item.title === '商品状态'"> 
              <div>{{row.spuStatus}}</div>
              <div>{{row.skuStatus}}</div>
            </span>
            <span v-else-if="item.title === '采购在途'"> 
              <el-button type="text" size="medium" @click="() => transitQuantity(row)">{{ row.purchaseOrderInTransit }}</el-button>
            </span>
            <span v-else-if="item.title === '首次上架时间'"> 
              <div>{{ moment(row.upDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
            </span>
            <span v-else-if="item.title === '备货周期'">
              {{ row.stockingDays }}
              <i class="el-icon-edit" type="edit" @click="handEdit(row, 3)"/>
            </span>
            <span v-else-if="item.title === '备注'">
              <el-tooltip v-if="row.stockingInstructions" class="item" effect="dark" placement="top-start">
                <div slot="content" style="width:200px">{{ row.stockingInstructions }}</div>
                <div class="ellipsis" style="width:250px;">{{ row.stockingInstructions }}</div>
              </el-tooltip>
              <i class="el-icon-edit" type="edit" @click="handEdit(row, 2)"/>
            </span>
            <span v-else-if="item.title === '预计回货日期'">
              {{ row.estimatedReturnDate ? moment(row.estimatedReturnDate).format('YYYY-MM-DD') : '-'}}
              <i class="el-icon-edit" type="edit" @click="handEdit(row, 1)"/>
            </span>
            <span v-else-if="item.title === '操作'" style="display: flex; flex-direction: column;">
              <el-button type="text" size="medium" @click="() => spuStatus(row)">修改状态</el-button>
              <el-button type="text" size="medium" style="margin:0px;" @click="() => kakaOutReturnSkuLog(row)">操作日志</el-button>
            </span>
            <span v-else> {{row[item.value]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 页脚 -->
    <footer class="common-footer">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>
    <!-- 操作日志对话框-->
    <el-dialog title="操作日志" :visible.sync="operationDialogVisible" width="1000px" :before-close="resetPage">
      <el-table :data="operationList" height="300px">
        <el-table-column prop="spuCode" label="SPU" width="160">
          <template slot-scope="{row}">
            <span>{{row.spuCode}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="skuCode" label="SKU" width="160">
          <template slot-scope="{row}">
            <span>{{row.skuCode}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="field" label="变更字段" width="130">
          <template slot-scope="{row}">
            <span>{{row.field}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fieldBefore" label="变更前" width="130">
          <template slot-scope="{row}">
            <span>{{row.fieldBefore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fieldAfter" label="变更后">
          <template slot-scope="{row}">
            <span>{{row.fieldAfter}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="操作人">
          <template slot-scope="{row}">
            <span>{{row.creator}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="操作时间">
          <template slot-scope="{row}">
            <span>{{moment(row.createDate).format('YYYY-MM-DD HH:mm:ss')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 采购在途详情对话框-->
    <el-dialog title="采购在途详情" :visible.sync="transitQuantityVisible" width="1000px" :before-close="resetPage">
      <el-table :data="transitQuantityList" height="300px">
        <el-table-column prop="plan_order_sn" label="到货计划单号" width="220">
          <template slot-scope="{row}">
            <span>{{row.plan_order_sn}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="from_order_type" label="单据类型">
          <template slot-scope="{row}">
            <span>{{row.from_order_type}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deliver_methods" label="送货方式">
          <template slot-scope="{row}">
            <span>{{row.deliver_methods}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="数量">
          <template slot-scope="{row}">
            <span>{{row.quantity}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="estimated_arrival_date" label="预计到货日期">
          <template slot-scope="{row}">
            <span>{{row.estimated_arrival_date}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 修改备货信息对话框-->
    <el-dialog :title="editForm.title" :visible.sync="editVisible" width="20%" :before-close="editCancel">
      <el-date-picker v-if="editForm.type === 1" v-model="editForm.estimatedReturnDate" type="date" clearable format="yyyy-MM-dd" @change="handleDatePicker"/>
      <el-input v-else-if="editForm.type === 2" v-model="editForm.stockingInstructions" clearable maxlength="250" show-word-limit>{{editForm.stockingInstructions}} </el-input>
      <div class="f" v-else-if="editForm.type === 3">
        <el-input v-model="editForm.daysFrom" clearable @input="handleStockingDaysInput(editForm.daysFrom, 1)" style="width:100px;"/> 
        <span style="width:20px;margin:12px;"> - </span> 
        <el-input v-model="editForm.daysTo"  clearable @input="handleStockingDaysInput(editForm.daysTo, 2)" style="width:100px;"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEdit" :loading="editLoading">修改</el-button>
      </span>
    </el-dialog>
    <!-- 修改状态对话框-->
    <el-dialog title="修改状态" :visible.sync="spuStatusVisible" width="20%" :before-close="resetPage">
      <div style="color:#ff0000"><span icon="el-icon-connection"/>修改商品系统成功后kaka状态才会变更</div>
      <div class="f" style="display: inline-block;margin-top:10px;">
          <div style="display: inline-block;margin-end:5px;">修改商品状态</div>
          <el-select v-model="spuStatusParameter.spuStatus" label="修改商品状态" size="medium" collapse-tags remote reserve-keyword style="display: inline-block;">
            <el-option label="缺货" value="40" />
            <el-option label="在售" value="10" />
            <el-option label="下架(滞销下架)" value="02" />
            <el-option label="下架(缺货下架)" value="01" />
            <el-option label="下架(品控下架)" value="03" />
            <el-option label="下架(侵权下架)" value="04" />
            <el-option label="下架(1688下架)" value="05" />
          </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="spuStatusVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSpuStatus" :loading="loading">保存</el-button>
      </span>
    </el-dialog>
    <!-- 列表字段配置对话框 -->
    <el-dialog title="列表字段配置" :visible.sync="itemVisible" width="800px" @close="closeItem" :close-on-click-modal="false">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
        <el-checkbox style="width:20%;margin-bottom:10px" v-for="(item,index) in columnTitles" :key="index" :label="item.value" :disabled="item.check">{{item.title}}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeItem">取 消</el-button>
        <el-button type="primary" @click="saveItem">保存</el-button>
      </span>
    </el-dialog>
    <!-- 自定义导出对话框 -->
    <el-dialog title="导出" :visible.sync="exportVisible" width="1280px" :before-close="closeExport">
      <div class="export-box">
        <div class="not-checked">
          <div class="tips">勾选区</div>
          <el-tabs v-model="exportActiveTabPane">
            <div class="checkout-all">
              <el-checkbox :indeterminate="orderIsIndeterminate" v-model="orderCheckAll" @change="handleOrderCheckAllChange">全选</el-checkbox>
            </div>
            <el-checkbox-group v-model="checkedOrderList" @change="handleCheckedOrderListChange">
              <el-checkbox v-for="order in orders" :disabled="order.required" :label="order.name" :key="order.code" />
            </el-checkbox-group>
          </el-tabs>
        </div>

        <div class="checked">
          <div class="tips">
            已选区 <span class="text">{{ selected.length }}</span>
          </div>
          <ul id="checked-drag" class="checked-group">
            <li v-for="item in selected" :key="item.code" :data-id="item.code" class="checked-group-item">
              <span>{{ item.name }}</span>
              <i v-if="!item.required" class="el-icon-close" @click="() => removeSelectedCheckboxItem(item.name)" />
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer">
        <el-button size="medium" @click="closeExport">取 消</el-button>
        <el-button type="primary" size="medium" @click="saveExport">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { Sortable } from 'sortablejs'
import _ from 'lodash'
import API from '@/api'
import { format } from 'echarts/core'
export default {
  props: {
    tabType: {
      type: Number,
      default: () => 1
    },
    categoryOptions: {
      type: Array,
      default: () => []
    },
    virtualWarehouses: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    filterMoney(value) {
      if (value || value === 0) {
        return value.toFixed(2)
      } else {
        return '-'
      }
    },
    imgToWebp(value) {
      return `${value}?x-oss-process=image/resize,w_98,h_98,m_fill/format,webp`
    }
  },
  data() {
    let parameter = {
      virtualWarehouseIds: [1], // 商品分组，默认是默认分组
      spuStatus: [], // 商品状态,"10" => '在售',"40" => '缺货',"00" => '下架',"01" => '下架（缺货下架）',"02" => '下架（滞销下架）',"03" => '下架（品控下架）',"04" => '下架（侵权下架）',"05" => '下架（1688下架）
      categoryIds: undefined, // 品类id
      supplierNames: [], // 供应商
      spuCurrentDevelopmentNames: [], // 买手
      spuBuyerNames: [], // 采购员
      stockingDays: undefined, // 预计回货天数
      paramType: 1, // spu销量和备货时间下拉
      totalSaleNumStart: 1, // SPU销量开始,默认是1
      totalSaleNumEnd: undefined, // SPU销量结束
      searchType: 1, // 批量搜索类型，1：spu，2：商品名称，3：备注，默认是spu搜索
      searchArray: undefined, // spu批量精确查询
      sort: 'desc', // 排序升序降序，asc,desc
      sortType: 1, // 排序字段（1：累计销量，2：近7天销量，3：近15天销量，4：近30天销量，5：累计退款，6：近7天退款，7：近15天退款，8：近30天退款，9当前缺货，10：缺货超3天，11：缺货超7天，12：缺货超15天，13：累计到仓回货，14：近7天到仓回货，15：近15天到仓回货，16：近30天到仓回货，17：在途采购单）
      pageNumber: 1, // 当前页
      pageSize: 20 // 每日显示条数
    }
    return {
      moment: moment, // 处理日期插件
      loading: false,
      parameter: { ...parameter, tabType: this.tabType }, // 表格数据请求参数
      productData: [], // 表格数据源
      kkProductIds: [], // 表格复选框当前选中行的id数组
      skuCodes: [], // 表格复选框当前选中行的sku数组
      total: 0, // 分页总数
      itemVisible: false, // 列表字段配置弹框 - 是否显示Dialog
      checkAll: false, // 列表字段配置弹框 - 是否全选
      isIndeterminate: true,
      columns: [
        { title: '商品信息', value: 'spuCode', width: 400, check: true , sort: false , fixed: 'left'},
        { title: '商品状态', value: 'spuStatus', width: 150, check: true , sort: false , fixed: 'left'},
        { title: '供应商', value: 'supplierName', width: 150, check: false , sort: false },
        { title: '商品分组', value: 'virtualWarehouseName', width: 150, check: false , sort: false},
        { title: '累计销量', value: 'totalSaleNum', width: 120, check: false , sort: true },
        { title: '当前缺货', value: 'currentOutStock', width: 120, check: false , sort: true },
        { title: '采购在途', value: 'purchaseOrderInTransit', width: 120, check: false , sort: true },
        { title: '用户刊登次数', value: 'publishCounts',  width: 150, check: false , sort: true },
        { title: '买手', value: 'spuCurrentDevelopmentName', width: 120, check: false, sort: false },
        { title: '采购', value: 'spuBuyerName', width: 120,  check: false , sort: false },
        { title: '备货周期', value: 'stockingDays', width: 120,  check: false , sort: false },
        { title: '备注', value: 'stockingInstructions', width: 250, check: false , sort: false },
        { title: '预计回货日期', value: 'estimatedReturnDate', width: 120, check: false , sort: false },
        { title: '首次上架时间', value: 'upDate', width: 160, check: false , sort: false },
        { title: '操作', value: 'operation', width: 100, check: true , sort: false, fixed: 'right' },
      ],
      checkList: [], // 列表字段配置显示数组
      columnTitles: [
        { title: '商品信息', value: 'spuCode', width: 400, check: true , sort: false , fixed: 'left'},
        { title: '商品状态', value: 'spuStatus', width: 150, check: true , sort: false , fixed: 'left'},
        { title: '供应商', value: 'supplierName', width: 150, check: false , sort: false },
        { title: '商品分组', value: 'virtualWarehouseName', width: 150, check: false , sort: false},
        { title: '累计销量', value: 'totalSaleNum', width: 120, check: false , sort: true },
        { title: '近7天销量', value: 'sevenDaysSaleNum', width: 120, check: false , sort: true },
        { title: '近15天销量', value: 'fifteenDaysSaleNum', width: 120, check: false, sort: true },
        { title: '近30天销量', value: 'thirtyDaysSaleNum', width: 120, check: false , sort: true },
        { title: '累计退款', value: 'totalRefundedNum', width: 120, check: false , sort: true },
        { title: '近7天退款', value: 'sevenRefundedNum', width: 120, check: false , sort: true },
        { title: '近15天退款', value: 'fifteenRefundedNum', width: 120, check: false , sort: true },
        { title: '近30天退款', value: 'thirtyRefundedNum', width: 120, check: false , sort: true },
        { title: '当前缺货', value: 'currentOutStock', width: 120, check: false , sort: true },
        { title: '缺货超3天', value: 'threeOutStock', width: 120,  check: false , sort: true },
        { title: '缺货超7天', value: 'sevenOutStock', width: 120,  check: false , sort: true },
        { title: '缺货超15天', value: 'fifteenOutStock', width: 120, check: false , sort: true },
        { title: '累计到仓回货', value: 'totalWarehouseNum', width: 150, check: false , sort: true },
        { title: '近7天到仓回货', value: 'sevenWarehouseNum', width: 150, check: false , sort: true },
        { title: '近15天到仓回货', value: 'fifteenWarehouseNum', width: 150, check: false , sort: true },
        { title: '近30天到仓回货', value: 'thirtyWarehouseNum', width: 150, check: false , sort: true },
        { title: '采购在途', value: 'purchaseOrderInTransit', width: 120, check: false , sort: true },
        { title: '刊登用户', value: 'publishUsers', width: 120, check: false , sort: true },
        { title: '刊登店铺', value: 'publishStores', width: 120, check: false , sort: true },
        { title: '用户刊登次数', value: 'publishCounts', width: 150, check: false , sort: true },
        { title: '买手', value: 'spuCurrentDevelopmentName', width: 120, check: false , sort: false },
        { title: '采购', value: 'spuBuyerName', width: 120, check: false , sort: false },
        { title: '备货周期', value: 'stockingDays', width: 120, check: false , sort: false },
        { title: '备注', value: 'stockingInstructions', width: 250, check: false , sort: false },
        { title: '预计回货日期', value: 'estimatedReturnDate', width: 120, check: false , sort: false },
        { title: '首次上架时间', value: 'upDate', width: 160, check: false , sort: false },
        { title: '操作', value: 'operation', width: 100, check: true , sort: false, fixed: 'right' },
      ],
      backUpColumn: [], // 后台返回的已选列表
      categoryValue: [],
      getSupplierLoading: false,
      operationList: [], // 操作日志
      operationDialogVisible: false, // 操作日志对话框 - 是否显示Dialog
      transitQuantityList: [], // 采购在途详情列表
      transitQuantityVisible: false, // 采购在途对话框
      supplierNames: [], // 供应商列表
      buyerStaffs: [], // 采购员工列表下拉框列表数据源
      stockingDaysSelect: [], // 预计回货时间下拉列表数据源
      params: {}, // 基础+更多筛选条件
      exportVisible: false, // 自定义导出对话框 - 是否显示对话框
      orderIsIndeterminate: false, // 全选按钮的半选中样式
      // 自定义导出对话框 - 订单信息
      orderCheckAll: false, // 是否全选
      orders: [], // 复选框数据源
      itemSelected: [], // 列表字段配置所有已选项
      selected: [], // 所有已选项
      exportActiveTabPane: 'order', // 自定义导出对话框 - Tabs当前激活项
      checkedOrderList: [], // 当前已选项
      // 导出字段中的英文标识对应关系
      correspondence: [],
      selection: [], // 表格当前选中行的ID数组
      spuStatusParameter: {
        kkProductIds: [], // spu维度，批量
        spuStatus: undefined, // spu或sku状态
        skuCodes: [] // sku维度，批量
      },
      spuStatusVisible: false, // 修改状态对话框，是否显示dialog

      editVisible: false,// 编辑对话框是否显示
      editLoading: false,// 修改按钮加载中
      editForm:{
        kkProductId: undefined,
        skuCode: undefined,
        stockingDays: undefined, // 备货周期
        daysFrom: undefined,
        daysTo: undefined,
        estimatedReturnDate: undefined, // 预计回货时间
        stockingInstructions: undefined, // 备注
        type: 1,// 类型，1：预计回货日期，2：备注，3：备货周期
        title: undefined,// 对话框标题
      }
    }
  },
  computed: {
    isLast() {
      return (data) => {
        return this.checkIsLast(data)
      }
    }
  },
  watch:{
    // 重新加载列表的样式
    "productData": {
      handler() {
        this.$nextTick(() => {
          this.$refs.multiTable.doLayout()
        });
      },
      deep: true
    },
    checkedOrderList(value) {
      this.setSelected(value, 'orders')
    },
  },
  created() {
    this.getSupplierNameList()
    this.spuSkuNamesSelect()
    this.getStockingDaysSelect()
    this.getBehaviorConfig()
    this.getKakaOutReturnSkuList()
  },
  activated() {
    this.getKakaOutReturnSkuList()
  },
  methods: {
    // 获取买手和采购下拉列表
    spuSkuNamesSelect() {
      API.spuSkuNamesSelect().then(({ data }) => {
        this.buyerStaffs = data
      })
    },
    // 获取备货周期下拉列表
    getStockingDaysSelect() {
      API.stockingDaysSelect().then(({ data }) => {
        this.stockingDaysSelect = data
      })
    },
    checkIsLast(data) {
      if (!data.childList) {
        return true
      } else {
        this.checkIsLast(data.childList)
      }
    },
    //获取供应商列表
    async getSupplierNameList(query) {
      try {
        if (query === undefined) query = ''
        this.getSupplierLoading = true
        let { data } = await API.getSupplieNameList({keyword: query})
        this.supplierNames = data
      } catch (error) {
        throw new Error(error.message)
      } finally {
        this.getSupplierLoading = false
      }
    },
    // 清空供应商，重新加载列表
    reloadSupplierNameList() {
      let query = ''
      this.getSupplierNameList(query)
    },
    // 销量输入框输入监听，只能输入数字
    handleInput(value, type) {
      // 移除非数字字符
      let newValue = value.replace(/[^0-9]/g, '');
      // 确保大于0
      newValue = newValue === '' ? '' : Math.max(parseInt(newValue, 10), 0).toString();
      if (type === 1) {
        this.parameter.totalSaleNumStart = newValue
      } else {
        this.parameter.totalSaleNumEnd = newValue
      }
    },
    // 获取动销报表
    async getKakaOutReturnSkuList(call = true, type) {
      try {
        this.loading = true
        if (call) this.resetPage()
        let newParameter = { ...this.parameter, tabType: this.tabType }
        newParameter.searchArray = newParameter.searchArray ? newParameter.searchArray.split('\n') : undefined
        let { data } = await API.getKakaOutReturnSkuList(newParameter)
        this.total = data.total
        this.productData = data.list.map(item => ({
          ...item,
          children: [],
          hasChildren: true,
          newStatus: item.status
        }))
        this.loading = false
      } catch (error) {
        this.loading = false
        throw new Error(error.message)
      }
      this.$tableScrollTop()
      // 编辑要清空折叠的sku信息然后重新加载
      if (type === 'edit') {
        let treeData = this.$refs.multiTable.store.states.treeData[+this.editForm.kkProductId]
        treeData.children = []
        treeData.expanded = false
        treeData.loaded = false
      }
    },
    // 显示编辑对话框
    handEdit(row, type) {
      this._initEditForm(row, type)
      this.editVisible = true
    },
    // 初始化修改备注表单
    _initEditForm(row, type) {
      this.editForm.kkProductId = row.kkProductId
      this.editForm.skuCode = row.skuCode
      this.editForm.type = type
      if (type === 1){
        this.editForm.estimatedReturnDate = row.estimatedReturnDate
        this.editForm.title = '修改预计回货时间'
      }else if (type === 2){
        this.editForm.stockingInstructions = row.stockingInstructions
        this.editForm.title = '修改备注'
      }else if (type === 3){
        this.editForm.stockingDays = row.stockingDays
        if (row.stockingDays && row.stockingDays.includes('-')) {
          const result = row.stockingDays.split('-')
          this.editForm.daysFrom = result[0]
          this.editForm.daysTo = result[1]
        }
        this.editForm.title = '修改备货周期'
      }
      
      this.$refs['copy-pack-form'] && this.$refs['copy-pack-form'].resetFields()
    },
    // 确认编辑
    async saveEdit() {
      try {
        this.editLoading = true
        if (this.editForm.type === 3){
          // 拼接
          this.editForm.stockingDays = this.editForm.daysFrom + '-' + this.editForm.daysTo
        }
        let result = await API.editReturnStocking(this.editForm)
        if (result.code === 10000) {
          this.$message.success(result.message)
          this.editVisible = false
          this.getKakaOutReturnSkuList(false, 'edit')
          // 重新加载备货周期
          if (this.editForm.type === 3) {
            this.getStockingDaysSelect()
          }
        } else {
          this.$message.error(result.message)
          this.editLoading = false
        }
      }catch(error) {
        throw new Error(error.message)
      } finally {
        this.editLoading = false
      }
    },
    // 对话框取消
    editCancel() {
      this.editVisible = false
    },
    // 备货周期输入框输入监听，只能输入数字
    handleStockingDaysInput(value, type) {
      // 移除非数字字符
      let newValue = value.replace(/[^0-9]/g, '');
      // 确保大于0
      newValue = newValue === '' ? '' : Math.max(parseInt(newValue, 10), 1).toString();
      newValue = newValue === '' ? '' : Math.min(parseInt(newValue, 10), 999).toString();
      if (type === 1) {
        this.editForm.daysFrom = newValue
      } else {
        this.editForm.daysTo = newValue
      }
    },
    // 处理日期，只取年月日
    handleDatePicker(value) {
      if (value === null){
        return
      }
      const date = new Date(value);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      this.editForm.estimatedReturnDate = `${year}-${month}-${day}`;
    },
    // 搜索列表
    searchGetProductList() {
      this.productData = []
      this.getKakaOutReturnSkuList()
    },
    resetPage() {
      this.parameter.pageNumber = 1
      this.operationDialogVisible = false
      this.spuStatusVisible = false
      this.transitQuantityVisible = false
    },

    // 获取品类列表
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },
    // 批量修改状态
    async batchSpuStatus() {
      this.selection.forEach((item) => {
        if (item.skuCode) {
          this.skuCodes.push(item.skuCode)
        }else{
          this.kkProductIds.push(item.kkProductId)
        }
      })
      this.spuStatusParameter.skuCodes = this.skuCodes
      this.spuStatusParameter.kkProductIds = this.kkProductIds
      this.spuStatusVisible = true
    },
    // 修改状态
    async spuStatus(row) {
      if (row.skuCode) {
        this.spuStatusParameter.skuCodes = [row.skuCode]
      } else {
        this.spuStatusParameter.kkProductIds = [row.kkProductId]
      }
      this.spuStatusVisible = true
    },
    // 确认修改状态
    async saveSpuStatus() {
      this.loading = true
      let result = await API.editSpuStatus(this.spuStatusParameter)
      if (result.code === 10000) {
        this.$message.success(result.data)
      } else {
        this.$message.error(result.message)
      }
      this.spuStatusParameter.spuStatus = undefined
      this.spuStatusParameter.kkProductIds = []
      this.spuStatusParameter.skuCodes = []
      this.kkProductIds = []
      this.skuCodes = []
      this.selection = []
      this.spuStatusVisible = false
      this.loading = false
    },
    // 操作日志
    async kakaOutReturnSkuLog(row) {
      try {
        let { data } = await API.getOperationLogList({
          kkProductId: row.kkProductId,
          skuCode: row.skuCode,
          pageNumber: 1,
          pageSize: 20
        })
        this.operationList = data.list
        this.operationDialogVisible = true
      } catch (error) {
        throw new Error(error.message)
      } finally {
        this.operationDialogVisible = true
      }
    },
    // 采购在途详情
    async transitQuantity(row) {
      try {
        let { data } = await API.getTransitQuantityList({
          kkProductId: row.skuCode === undefined ? row.kkProductId : undefined,
          skuCode: row.skuCode
        })
        this.transitQuantityList = data
        this.transitQuantityVisible = true
      } catch (error) {
        throw new Error(error.message)
      } finally {
        this.transitQuantityVisible = true
      }
    },
    // 筛选 - 商品品类级联选择器选中值发生变化时的回调
    selectCategory(value) {
      if (!value.length) {
        this.parameter.categoryIds = undefined
      } else {
        this.parameter.categoryIds = value
      }
      this.productData = []
      this.getKakaOutReturnSkuList()
    },
    // 当表格复选框选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      // console.log('444', selection)
      // this.kkProductIds = selection.map((item) => item.kkProductId)
      // this.skuCodes = selection.map.map((item) => item.skuCode)
      this.selection = selection
    },

    // 当表格的排序条件发生变化的时候会触发该事件
    tableSortChange({ prop, order }) {
      this.parameter.sort = 'asc'
      if (order === 'descending') {
        this.parameter.sort = 'desc'
      }
      
      if (prop === 'totalSaleNum') {
        // 累计销量
        this.parameter.sortType = 1
      } else if (prop === 'sevenDaysSaleNum') {
        // 近7天销量
        this.parameter.sortType = 2
      } else if (prop === 'fifteenDaysSaleNum') {
        // 近15天销量
        this.parameter.sortType = 3
      } else if (prop === 'thirtyDaysSaleNum') {
        // 近30天销量
        this.parameter.sortType = 4
      }else if (prop === 'totalRefundedNum') {
        // 累计退款
        this.parameter.sortType = 5
      }else if (prop === 'sevenRefundedNum') {
        // 近7天退款
        this.parameter.sortType = 6
      }else if (prop === 'fifteenRefundedNum') {
        // 近15天退款
        this.parameter.sortType = 7
      }else if (prop === 'thirtyRefundedNum') {
        // 近30天退款
        this.parameter.sortType = 8
      }else if (prop === 'currentOutStock') {
        // 当前缺货
        this.parameter.sortType = 9
      }else if (prop === 'threeOutStock') {
        // 缺货超3天
        this.parameter.sortType = 10
      }else if (prop === 'sevenOutStock') {
        // 缺货超7天
        this.parameter.sortType = 11
      }else if (prop === 'fifteenOutStock') {
        // 缺货超15天
        this.parameter.sortType = 12
      }else if (prop === 'totalWarehouseNum') {
        // 累计到仓回货
        this.parameter.sortType = 13
      }else if (prop === 'sevenWarehouseNum') {
        // 近7天到仓回货
        this.parameter.sortType = 14
      }else if (prop === 'fifteenWarehouseNum') {
        // 近15天到仓回货
        this.parameter.sortType = 15
      }else if (prop === 'thirtyWarehouseNum') {
        // 近30天到仓回货
        this.parameter.sortType = 16
      }else if (prop === 'purchaseOrderInTransit') {
        // 在途采购单
        this.parameter.sortType = 17
      }else if (prop === 'publishUsers') {
        // 刊登用户
        this.parameter.sortType = 18
      }else if (prop === 'publishStores') {
        // 刊登店铺
        this.parameter.sortType = 19
      }else if (prop === 'publishCounts') {
        // 用户刊登次数
        this.parameter.sortType = 20
      }
      this.getKakaOutReturnSkuList()
    },
    // 每页显示条数改变时的回调
    handleSizeChange(value) {
      this.parameter.pageSize = value
      this.getKakaOutReturnSkuList(false)
    },
    // 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.parameter.pageNumber = value
      this.getKakaOutReturnSkuList(false)
    },
    tableRowKey(record) {
      return record.skuCode ? `${record.skuCode}` : `${record.kkProductId}`
    },
    dataChildrenLoad(tree, treeNode, resolve) {
      this.getChild(tree.kkProductId, this.tabType, resolve)
    },

    getChild(kkProductId, tabType, resolve) {
      API.getChildSku({ kkProductId, tabType }).then((res) => {
        resolve(res.data.map(item => ({ ...item, newStatus: item.skuStatus })))
      })
    },
    showDialog() {
      this.itemVisible = true,
      this.checkList = this.columns.map(item => item.value)
      this.backUpColumn = _.cloneDeep(this.checkList)
    },
    closeItem() {
      this.checkList = _.cloneDeep(this.backUpColumn)
      this.itemVisible = false
      let checkedCount = this.checkList.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },
    handleCheckAllChange(val) {
      this.checkList = val ? this.columnTitles.map(item => item.value) : ['spuCode','spuStatus','operation']
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },
    saveItem() {
      this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.value))
      // 获取选中的值
      this.itemSelected = _.cloneDeep(this.columns).map(item => item.title)
      this.setBehaviorConfig()
      // this.parameter.showFields = [...this.checkList, 'productInfo', 'status']
      this.getKakaOutReturnSkuList(false)
      this.backUpColumn = this.checkList
      this.itemVisible = false
      this.$forceUpdate()
    },
    getBehaviorConfig() {
      // 获取全部商品的列表字段显示
      API.getBehaviorConfig(8).then((res) => {
        if (!res.data) return
        this.checkList = res.data.content
        this.$set(this.$data, 'columns', _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.title)))
        this.configId = res.data.id
      })
    },
    setBehaviorConfig() {
      const params = {
          type: 8,
          content: JSON.stringify(this.itemSelected),
          id: this.configId
      }
      API.setBehaviorConfig(params)
    },
    dataExport() {
      this.exportVisible = true
      this.drag()
      this.getPublicSelectData()
    },
    /**
     * 拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
     drag() {
      this.$nextTick(() => {
        let element = document.getElementById('checked-drag')
        if (element) {
          new Sortable(element, {
            handle: '.checked-group-item',
            draggable: '.checked-group-item',
            animation: 500,
            dataIdAttr: 'data-id'
          })
        }
      })
    },
    /**
     * API 获取可导出字段的列表
     */
     async getPublicSelectData() {
      try {
        let { data } = await API.getPublicSelectData({ type: 12, param: undefined })
        let { data: selectedFields } = await API.getExportFieldRecords(9)
        if (selectedFields) {
          this.selectedFieldsId = selectedFields.id
          selectedFields = JSON.parse(selectedFields.content)
        }
        if (data) {
          this.exportFields = data
          data.forEach((item) => {
            this.correspondence.push(item.fields)
            if (item.fields && item.fields.length) {
              this.orders = item.fields
              if (selectedFields) {
                this.checkedOrderList = [...selectedFields.orderInfo]
              } else {
                item.fields.forEach((field) => {
                  if (field.required) {
                    this.checkedOrderList.push(field.name)
                  }
                })
              }
              if (this.checkedOrderList.length === item.fields.length) {
                this.orderCheckAll = true
                this.orderIsIndeterminate = false
              }
              if (this.checkedOrderList.length > 0 && this.checkedOrderList.length < item.fields.length) {
                this.orderCheckAll = false
                this.orderIsIndeterminate = true
              }
            } else {
              this.orders = []
            }
            
          })
          this.correspondence = this.correspondence.flat()
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    /**
     * 自定义导出对话框 - 订单信息全选按钮事件
     * @param {Boolean} value 是否全选
     */
     handleOrderCheckAllChange(value) {
      if (value) {
        this.checkedOrderList = this.orders.map((item) => item.name)
      } else {
        this.checkedOrderList = []
        this.orders.forEach((item) => {
          if (item.required) {
            this.checkedOrderList.push(item.name)
          }
        })
      }
      if (this.checkedOrderList.length && this.checkedOrderList.length < this.orders.length) {
        this.orderIsIndeterminate = true
      } else {
        this.orderIsIndeterminate = false
      }
    },
    /**
     * 自定义导出对话框 - 订单信息某个复选框被勾选的事件
     * @param {Array} value 已勾选的复选框数组
     */
     handleCheckedOrderListChange(value) {
      let checkedCount = value.length
      this.orderCheckAll = checkedCount === this.orders.length
      this.orderIsIndeterminate = checkedCount > 0 && checkedCount < this.orders.length
    },
    /**
     * 自定义导出对话框 - 设置已勾选项
     * @param {Array} value 已勾选的复选框数组
     * @param {String} original 可选项数组
     */
     setSelected(value, original) {
      let selected = []
      let unchecked = []
      this[original].forEach((item) => {
        if (value.includes(item.name)) {
          selected.push(item.name)
        } else {
          unchecked.push(item.name)
        }
      })
      unchecked.forEach((item) => {
        this.selected.forEach((inside, index) => {
          if (item === inside.name) {
            this.selected.splice(index, 1)
          }
        })
      })
      this.correspondence.forEach((item) => {
        if (selected.includes(item.name)) {
          this.selected = Array.from(new Set([...this.selected, item]))
        }
      })
    },
    /**
     * 自定义导出对话框 - 删除某个已选的复选框
     * @param {String} value 当前删除的复选框的值
     */
     removeSelectedCheckboxItem(value) {
      if (this.checkedOrderList.includes(value)) {
        this.checkedOrderList = this.checkedOrderList.filter((item) => item !== value)
        this.handleCheckedOrderListChange(this.checkedOrderList)
      }
      this.selected = this.selected.filter((item) => item.name !== value)
    },

    /**
     * 自定义导出 - 对话框保存按钮的事件
     */
    saveExport() {
      if (this.selected.length === 0) {
        this.$message.warning('请选择需要导出的字段!')
        return
      }

      let ul = document.getElementById('checked-drag')
      let selected = []
      Array.from(ul.children).forEach((li) => {
        selected.push(li.getAttribute('data-id'))
      })

      let ids = []
      ids = this.selection.map((row) => row.kkProductId).filter(Boolean)
      let newParameter = { ...this.parameter, tabType: this.tabType }
      newParameter.searchArray = newParameter.searchArray ? newParameter.searchArray.split('\n') : undefined
      const params = {
        fileType: 2,
        taskType: 23,
        condition: JSON.stringify({
          arrayIds: ids,
          searchContent: newParameter,
          sortFields: [...selected]
        })
      }

      let obj = {
        orderInfo: [], // 订单信息
      }

      this.exportFields.forEach((item) => {
        if (item.code === 'order_info') {
          item.fields.forEach((field) => {
            if (selected.includes(field.code)) {
              obj.orderInfo.push(field.name)
            }
          })
        }
      })

      API.setExportFieldRecords({ id: this.selectedFieldsId ? this.selectedFieldsId : undefined, type: 9, content: JSON.stringify(obj) })
        .then(() => {})
        .catch(() => {})

      API.dashboardImportExportFile(params)
        .then(() => {
          this.closeExport()
          this.$message.success('操作成功，请到导入导出管理查看')
        })
        .catch(() => {
          this.$message.error('导出失败，请重新操作')
        })
    },

    /**
     * 自定义导出 - 对话框关闭的事件
     */
     closeExport() {
      this.exportVisible = false
      this.clear()
    },

    /**
     * 自定义导出 - 负责清除数据方法
     */
    clear() {
      this.correspondence = []
      this.orderCheckAll = false
      this.checkedOrderList = []
      this.orderIsIndeterminate = false
      this.selected = []
    },
    columnConfigureSubmit(column) {
      this.showColumns = column
      this.columnInfo.content = JSON.stringify(column)
      this.changeShowColumns(column)
    },
  }
}
</script>

<style lang="scss" scoped>
.common-header {
  // display: flex;
  width: 100%;
  height: 10%;
  align-items: center;
  .left {
    > div {
      margin-bottom: 5px;
      margin-right: 5px;
    }
    > button {
      margin-bottom: 5px;
      margin-right: 5px;
    }
    .el-input {
      width: 320px;
      .el-select {
        width: 100px;
      }
    }
    .rightBorderNone {
      margin-right: 0 !important;
      /deep/.el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        // border-right: none;
      }
    }
  }
}
.errorType {
  margin-top: 10px;
}

.common-section {
  height: calc(103vh - 294px);
  margin: 2px 0;
  .stock-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f5f7fa;
    user-select: none;
    cursor: pointer;
  }

  .status {
    width: 80px;
    height: 36px;
    border-radius: 40px;
    .left {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}

.common-footer {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
/deep/.el-input-group__prepend {
  background-color: #fff !important;
}
/deep/.el-table__expand-icon {
  transform: rotate(0deg);
  > .el-icon-arrow-right::before {
    content: '\e6d9';
    border: 1px solid #ccc;
    padding: 1px;
  }
}
/deep/.el-table__expand-icon--expanded {
  .el-icon-arrow-right::before {
    content: '\e6d8';
  }
}
.errorTypeActive {
  color: #909399;
}
/deep/.el-table__row--level-0 {
  > td:nth-of-type(2) {
    .cell {
      display: flex;
      align-items: center;
    }
  }
}
.el-tooltip__popper {
  max-width: 250px;
  word-wrap: break-word;
}
.export-box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #e9e9e9;
    .not-checked,
    .checked {
      padding: 10px;
      .tips {
        line-height: 18px;
        margin-bottom: 10px;
        .text {
          color: #99c41c;
          font-weight: 700;
        }
      }
    }

    .not-checked {
      flex: 9;
      border-right: 1px solid #e9e9e9;
      /deep/.el-tabs__content {
        .el-tab-pane {
          overflow: auto;
        }
      }
      .checkout-all {
        margin-bottom: 10px;
      }
      .el-checkbox-group {
        .el-checkbox {
          width: 30%;
          margin-right: 22px !important;
          margin-bottom: 6px !important;
        }
      }
    }

    .checked {
      flex: 3;
      .checked-group {
        width: 100%;
        min-height: 280px;
        max-height: 480px;
        height: calc(100% - 28px);
        overflow-y: auto;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        .checked-group-item {
          display: flex;
          width: 100%;
          line-height: 28px;
          padding: 5px 8px;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #dcdfe6;
          user-select: none;
          cursor: move;
          span {
            max-width: 258px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          i {
            width: 25px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #f56c6c;
          }
        }
      }
    }
  }
}
</style>
